import React from 'react';
import styled from "styled-components";

const SGrammarPasiva = styled.div`
  flex: 1;
  padding: 5px 20px;
`;

const GrammarPasiva = () => {
  return (
    <SGrammarPasiva>
<h5>Strona bierna - La vos pasiva</h5>
Strona bierna jest bardzo rzadko używana w języku hiszpańskim. Tworzy się ją używając czasownika <b>SER</b> gdy 
kładzie się nacisk na samą czynność lub <b>ESTAR</b> gdy ważny jest skutek czynności (nie jest podany sprawca czynności).<br/><br/>

Stronę czynną zamienia się na stronę bierną według schematu:<br/><br/>
<b>rzeczownik 1</b> + czasownik + rzeczownik 2<br/>
w<br/>
<b>rzeczownik 2</b> + ser/estar + imiesłów (participio) + por + rzeczownik 1<br/>

<i>Uwaga</i>: ser/estar - w odpowiednim czasie; imiesłów danego czasownika uzgodniony
 w liczbie i rodzaju z rzeczownikiem 2.<br/><br/>

Przykład:<br/>
<i>Ana escribió la carta.</i> - Anna napisała list.<br/>
<i>La carta fue escrita por Ana.</i> - List został napisany przez Annę.<br/>
(ale:) <i>La carta está escrita.</i> - List jest napisany.<br/><br/>

<b>Kilka uwag:</b>
<li>Często używa się formy bezosobowej czasownika zamiast strony biernej
 (na język polski takie zdania tłumaczymy zawsze w liczbie pojedyńczej):<br/>
Se + czasownik w 3 os. l. poj. + rzeczownik w l. poj.<br/>
Se + czasownik w 3 os. l. mn. + rzeczownik w l. mn.<br/>
<i>Se vende pan.</i> - Sprzedaje się chleb.<br/>
<i>Se venden pasteles.</i> - Sprzedaje się ciastka.<br/>
</li>
<li>Jeśli rzeczownik oznacza osobę, czasownik zawsze jest w liczbie
pojedynczej.<br/>
<i>En esta ciudad se ve a muchos turistas.</i> - W tym
 mieście widzi się wielu turystów.<br/>
</li>
<li>Jeśli czasownik występuje w formie zwrotnej, dodaje się podmiot
 "uno/a".<br/>
<i>Uno se acuerda de lo ocurrido a menudo.</i> - Często
 się wspomina to, co zaszło.<br/>
</li>
<li>Forma bezosobowa może wystąpić w zdaniu typu:</li>
Se + czasownik 3 os. l. poj. + que + zdanie<br/>
<i>Se dice que el domingo va a hacer calor.</i> - Mówi się, że w niedzielę
 będzie ciepło.
    </SGrammarPasiva>
  )
};

export default GrammarPasiva;